import { ConcreteEncodable } from "./ConcreteEncodable";

import { CredentialChangeEventImplEncoder } from "../../encoder/CredentialChangeEventImplEncoder";

import * as CubiqTS from "../../index";
import { CredentialChangeEvent } from "../CredentialChangeEvent";

export class CredentialChangeEventImpl extends ConcreteEncodable implements CredentialChangeEvent {
  public static enType: string = "com.bcdfx.model.CredentialChangeEventImpl";

  /*FID=1*/
  public credential: string;
  /*FID=2*/
  public userCd: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = CredentialChangeEventImplEncoder.Instance;
    this.setEncodableType(CredentialChangeEventImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "CredentialChangeEventImpl[" +
      "credential=" +
      this.credential +
      "userCd=" +
      this.userCd +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
